<div class="d-flex mb-2">
  @if (isChecked) {
    <fa-icon
      wlAutomationId="icon-check"
      class="d-essent text-success fa-fw"
      icon="check"
    ></fa-icon>
    <fa-icon
      wlAutomationId="icon-check"
      class="d-ed text-success fa-fw"
      icon="circle-check"
    >
    </fa-icon>
  } @else {
    <fa-icon
      wlAutomationId="icon-cross"
      class="d-essent text-body-secondary fa-fw"
      icon="xmark"
    ></fa-icon>
    <fa-icon
      wlAutomationId="icon-cross"
      class="d-ed text-body-secondary fa-fw"
      icon="circle-xmark"
    >
    </fa-icon>
  }
  <div class="ms-1">
    <p class="mb-0 checklist-item__title" [wlAutomationId]="titleAutomationId">
      {{ title }}
    </p>
    <wl-rich-text-wrapper [field]="description" [rendering]="rendering">
      @if (description) {
        <p
          class="small mb-0 checklist-item__description"
          [wlAutomationId]="descriptionAutomationId"
        ></p>
      }
    </wl-rich-text-wrapper>
  </div>
</div>
